import React from 'react';

function RewardBanner() {
    return (
        <div className="flex flex-col md:flex-row justify-between mx-5 items-center bg-[#F6C091] p-4 rounded-lg">
            {/* Text Section */}
            <div className="text-gray-800">
                <h1 className="text-2xl md:text-4xl text-center font-semibold mb-2">REWARD POINTS PROGRAM</h1>
                <p className="text-lg bg-gray-800 p-1 w-full text-white text-center mb-2">
                    EARN POINTS ON EVERY PURCHASE YOU MAKE
                </p>
                <div className="flex flex-row justify-center md:justify-start gap-2 w-full md:w-1/2 mx-auto md:mx-0">
                    <div className="text-sm w-1/4 md:w-1/2  text-center p-3 bg-[#FFD336CC] font-semibold">
                        <p>EARN</p>
                        <span className="text-lg">5</span>
                        <p>POINTS</p>
                    </div>
                    <div className="text-sm text-center w-1/4 md:w-1/2 p-3 bg-[#FFD336CC] font-semibold">
                        <p>EVERY</p>
                        <span className="text-lg">1</span>
                        <p>DOLLAR</p>
                        <p>SPENT</p>
                    </div>
                </div>
                <p className="text-sm md:text-base w-full md:w-1/2 font-semibold my-4 border-t-2 border-b-2 border-black py-2 text-center mx-auto md:mx-0">
                    100 POINTS = $1
                </p>
                <p className="text-sm md:text-base font-normal w-full md:w-1/2 bg-red-500 text-white text-center p-2 mx-auto md:mx-0">
                    MORE WAYS TO EARN BELOW
                </p>
            </div>
            {/* Image Section */}
            <div className="flex justify-center mt-4 md:mt-0">
                <div className='w-full h-80'>
                    <img
                        src="/images/icons/rank.png" // Corrected to use forward slashes
                        alt="Rank Icon"
                        className="w-full h-full object-contain rounded-lg"
                    />
                </div>
            </div>
        </div>
    );
}

export default RewardBanner;
